import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { useState } from "react";

import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import "@/datefield.css";

const toIso = (d) => format(d, "yyyy-MM-dd");
const parse = (v) => (v ? parseISO(v) : undefined);

// Sélecteur de date en français (lundi en premier), valeur au format AAAA-MM-JJ comme un champ date classique
export function DateField({ value, onChange, min, max, disabled, placeholder = "Choisir une date", clearable = true, className = "", testid }) {
  const [open, setOpen] = useState(false);
  const selected = parse(value);
  const pick = (d) => { if (d) { onChange(toIso(d)); setOpen(false); } };
  const blocked = [min && { before: parse(min) }, max && { after: parse(max) }].filter(Boolean);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <span className="df-wrap">
        <PopoverTrigger asChild>
          <button type="button" className={`df-trigger${value ? "" : " empty"}${clearable && value && !disabled ? " has-clear" : ""} ${className}`} disabled={disabled} data-testid={testid}>
            <CalendarDays size={14} />
            <span>{selected ? format(selected, "d MMM yyyy", { locale: fr }) : placeholder}</span>
          </button>
        </PopoverTrigger>
        {clearable && value && !disabled && <button type="button" className="df-clear" onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange(""); setTimeout(() => setOpen(false), 0); }} title="Effacer la date" aria-label="Effacer la date" data-testid={testid && `${testid}-clear`}><X size={13} /></button>}
      </span>
      <PopoverContent className="df-pop" align="start" data-testid={testid && `${testid}-calendar`}>
        <Calendar mode="single" locale={fr} weekStartsOn={1} selected={selected} defaultMonth={selected || parse(min) || undefined} onSelect={pick} disabled={blocked} initialFocus />
        <div className="df-foot">
          <button type="button" onClick={() => pick(new Date())} disabled={(min && toIso(new Date()) < min) || (max && toIso(new Date()) > max)} data-testid={testid && `${testid}-today`}>Aujourd'hui</button>
          {clearable && value && <button type="button" onClick={() => { onChange(""); setOpen(false); }}>Effacer</button>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
